import { render, staticRenderFns } from "./UsersComponent.vue?vue&type=template&id=625cb2ad&scoped=true"
import script from "./UsersComponent.vue?vue&type=script&lang=js"
export * from "./UsersComponent.vue?vue&type=script&lang=js"
import style0 from "./UsersComponent.vue?vue&type=style&index=0&id=625cb2ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625cb2ad",
  null
  
)

export default component.exports